export default (entity = {}) => {
    return {
        id: entity.id || undefined,
        name: entity.name || '',
        isClub: entity.isClub || false
    };
};
